import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import {
  ProcessingItemState,
  useActionButtonContext,
} from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import { useCallback } from 'react';
import { useContactDetailsLoading } from './use-contact-details-loading';

export function useContactDetailFieldLoading(item?: PeopleTableInfo) {
  const { loading } = useContactDetailsLoading(item);
  const { getItemState } = useActionButtonContext();

  const processingState = getItemState({
    id: item?.id ?? '',
    type: QUICK_INFO_BUTTONS.CONTACT_ENRICHMENT,
  });

  // CONTACT_UPDATE_JOB_CHANGE refreshes only the experience field on a
  // never-unlocked profile, but refreshes all fields once the profile
  // is unlocked.
  const isExperienceOnlyUpdate =
    processingState === ProcessingItemState.UPDATING_JOB_CHANGE &&
    !item?.revelation?.contact?.state;

  const isFieldLoading = useCallback(
    (field: PersonContactDetailsItem) => {
      if (!loading) return false;
      if (isExperienceOnlyUpdate)
        return field === PersonContactDetailsItem.EXPERIENCE;
      return true;
    },
    [loading, isExperienceOnlyUpdate]
  );

  return { isFieldLoading, loading };
}
